export default __webpack_public_path__ + "static/media/php.436176e5.jpeg";